import ErrorPagePortal from "./ErrorPagePortal";

export default ErrorPagePortal;
